import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { tempUrl, useStateContext } from "../../../contexts/ContextProvider";
import { AuthContext } from "../../../contexts/AuthContext";
import { Loader, ScrollToTop } from "../../../components";
import { FetchErrorHandling } from "../../../components/FetchErrorHandling";
import { Box, Button, Divider, Paper, Snackbar, Alert, Typography } from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import EditIcon from "@mui/icons-material/Edit";
import { Col, Row, Form } from "react-bootstrap";

const fieldGroups = [
  [
    ["noSuratSomasiTahap2", "No. Surat", "text"],
    ["tglSuratSomasiTahap2", "Tanggal Surat", "date"],
    ["noJual", "No. Jual", "text"],
    ["namaRegister", "Nama Register", "text"],
    ["tanggalJual", "Tanggal Jual", "date"],
    ["almRegister", "Alamat Register", "text"],
    ["tlpRegister", "Telepon Register", "text"],
  ],
  [
    ["noRangka", "No. Rangka", "text"],
    ["noMesin", "No. Mesin", "text"],
    ["tipe", "Tipe", "text"],
    ["tahun", "Tahun", "text"],
    ["nopol", "No. Polisi", "text"],
    ["namaWarna", "Nama Warna", "text"],
    ["suratSomasiKe", "Tahap Somasi", "number"],
    ["kodeKolektor", "Kode Eksekutor", "text"],
  ],
];

const UbahSuratSomasiTahap2 = () => {
  const { user, dispatch } = useContext(AuthContext);
  const { screenSize } = useStateContext();
  const location = useLocation();
  const navigate = useNavigate();
  const id = location.pathname.split("/")[2];
  const [values, setValues] = useState({});
  const [validated, setValidated] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [isFetchError, setIsFetchError] = useState(false);
  const textRight = { textAlign: screenSize >= 650 ? "right" : undefined };
  const authBody = { id: user._id, token: user.token, kodeCabang: user.cabang ? user.cabang._id : undefined };

  useEffect(() => {
    const getData = async () => {
      setLoading(true);
      try {
        const response = await axios.post(tempUrl + "/suratSomasiTahap2s/" + id, authBody);
        const row = response.data || {};
        const dateFields = ["tglSuratSomasiTahap2", "tanggalJual"];
        dateFields.forEach((field) => {
          if (row[field]) row[field] = String(row[field]).split("T")[0];
        });
        setValues(row);
      } catch (requestError) {
        if (requestError.response && requestError.response.status === 401) {
          dispatch({ type: "LOGOUT" });
          navigate("/");
        } else {
          setIsFetchError(true);
        }
      } finally {
        setLoading(false);
      }
    };
    getData();
  }, [id]);

  const updateData = async (event) => {
    event.preventDefault();
    if (!values.noSuratSomasiTahap2 || !values.tglSuratSomasiTahap2 || !values.noJual || !values.namaRegister) {
      setValidated(true);
      setError("No. Surat, tanggal, No. Jual, dan nama register wajib diisi.");
      return;
    }
    setLoading(true);
    try {
      await axios.post(tempUrl + "/updateSuratSomasiTahap2/" + id, { ...values, ...authBody });
      navigate("/suratSomasiTahap2/" + id);
    } catch (requestError) {
      if (requestError.response && requestError.response.status === 401) {
        dispatch({ type: "LOGOUT" });
        navigate("/");
      } else {
        setError(requestError.response && requestError.response.data && requestError.response.data.message || "Gagal mengubah data.");
      }
    } finally {
      setLoading(false);
    }
  };

  const renderField = ([name, label, type]) => (
    <Row key={name}><Col><Form.Group as={Row} className="mb-3">
      <Form.Label column sm="4" style={textRight}>{label} :</Form.Label>
      <Col sm="8"><Form.Control required={["noSuratSomasiTahap2", "tglSuratSomasiTahap2", "noJual", "namaRegister"].includes(name)} type={type} name={name} value={values[name] || ""} onChange={(event) => setValues({ ...values, [name]: event.target.value })} /></Col>
    </Form.Group></Col></Row>
  );

  if (loading) return <Loader />;
  if (isFetchError) return <FetchErrorHandling />;
  return (
    <Box>
      <ScrollToTop />
      <Typography color="#757575">Piutang</Typography>
      <Typography variant="h4" sx={subTitleText}>Ubah Surat Somasi Tahap 2</Typography>
      <Divider sx={dividerStyle} />
      <Paper sx={contentContainer} elevation={12}>
        <Form noValidate validated={validated} onSubmit={updateData}>
          <Box sx={showDataContainer}>
            <Box sx={showDataWrapper}>{fieldGroups[0].map(renderField)}</Box>
            <Box sx={[showDataWrapper, secondWrapper]}>{fieldGroups[1].map(renderField)}</Box>
          </Box>
          <Box sx={buttonContainer}>
            <Button variant="outlined" color="secondary" onClick={() => navigate("/suratSomasiTahap2/" + id)} sx={{ marginRight: 2 }}>{"< Kembali"}</Button>
            <Button variant="contained" startIcon={<EditIcon />} type="submit">Ubah</Button>
          </Box>
        </Form>
      </Paper>
      <Snackbar open={Boolean(error)} autoHideDuration={5000} onClose={() => setError("")}><Alert severity="error">{error}</Alert></Snackbar>
    </Box>
  );
};

export default UbahSuratSomasiTahap2;

const subTitleText = { fontWeight: "900" };
const dividerStyle = { pt: 4 };
const contentContainer = { mt: 4, p: 4 };
const showDataContainer = { display: "flex", flexDirection: { xs: "column", sm: "row" } };
const showDataWrapper = { display: "flex", flex: 1, flexDirection: "column", maxWidth: { md: "40vw" } };
const secondWrapper = { marginLeft: { sm: 4 }, marginTop: { sm: 0, xs: 4 } };
const buttonContainer = { mt: 3, display: "flex", justifyContent: "center" };
